/**
 * Check for page types, e.g. Article, Video, Logout, Inbox-News...
 */
class PageType {
  private readonly isLogoutPage_: boolean;
  private readonly isInboxNewsPage_: boolean;

  constructor() {
    // check for logout page
    this.isLogoutPage_ = document.getElementsByClassName('logout').length > 0;
    this.isInboxNewsPage_ = document.getElementsByClassName('inboxnews').length > 0;
  }

  get isLogoutPage() {
    return this.isLogoutPage_;
  }

  get isInboxNewsPage() {
    return this.isInboxNewsPage_;
  }
}

const pageType = new PageType();
export default pageType;
